import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { Router } from '@angular/router';
import { TCustomer } from 'src/app/modules/admin/customers/customers.types';
import Session from 'store-management';
import { CustomerSwitchService } from '../../services/customer-switch/customer-switch.service';
import { TUser } from '../../types';
import { hasRole } from '../../utils/string';

@Component({
  selector: 'cohrex-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TopnavComponent implements OnInit {
  show = false;
  collapsed = false;
  session!: Session;

  private _sideNavHidden?: boolean = false;
  @Input()
  set sideNavHidden(value: boolean | undefined) {
    this._sideNavHidden = value;
  }

  get sideNavHidden(): boolean | undefined {
    return this._sideNavHidden;
  }

  customerSwitched: boolean = false;
  activeCustomer?: TCustomer;

  @Output()
  collapseNav: EventEmitter<boolean> = new EventEmitter();
  @Output()
  sideNavHiddenOnMobile: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private customerSwitchService: CustomerSwitchService,
    private router: Router
  ) {
    this.session = new Session();
    this.customerSwitchService
      .isCustomerSwitched()
      .subscribe((switched: boolean): void => {
        if (!switched) {
          this.session.forget('activeCustomer');
          this.router.navigate(['/admin/dashboard']);
          return;
        }
        this.activeCustomer = this.session.get('activeCustomer');
        this.customerSwitched = Boolean(this.activeCustomer);
      });
    this.activeCustomer = this.session.get('activeCustomer');
  }

  ngOnInit(): void {
    const user = this.session.get('user') as TUser;
    this.customerSwitched =
      Boolean(this.session.get('activeCustomer')) &&
      hasRole(user.roles, 'superadmin');
  }

  setCollapsed() {
    this.collapsed = !this.collapsed;
    this.sideNavHidden = !this.sideNavHidden;
    this.collapseNav.emit(this.collapsed);
    this.sideNavHiddenOnMobile.emit(this.sideNavHidden);
  }

  handleDeactiveActiveCustomer() {
    this.customerSwitched = false;
    this.customerSwitchService.next(false);
  }
}
